import { getRecaptchaKey } from './getRecaptchaKey';
import { ensureRecaptcha } from './loader';

export function initRecaptcha() {
  const siteKey = getRecaptchaKey();
  if (siteKey) void ensureRecaptcha(siteKey);
}

export async function getRecaptchaToken(action: string) {
  const siteKey = getRecaptchaKey();
  if (!siteKey) throw new Error('reCAPTCHA siteKey is not set');

  const grecaptcha = await ensureRecaptcha(siteKey);
  return grecaptcha.execute(siteKey, { action });
}
